import { render, staticRenderFns } from "./GlobalCta.vue?vue&type=template&id=028dd7c6&scoped=true&"
import script from "./GlobalCta.vue?vue&type=script&lang=js&"
export * from "./GlobalCta.vue?vue&type=script&lang=js&"
import style0 from "./GlobalCta.vue?vue&type=style&index=0&id=028dd7c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028dd7c6",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/GlobalCta.vue
// module id = 188
// module chunks = 0